import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import Videos from './Videos'
import Portfolio from './Portfolio'
import Polaroids from './Polaroids'
import Covers from './Covers'
import Bio from './Bio'

import s from './ModelContent.module.css'
import CollapsibleContent from '../CollapsibleContent'

function ModelContent({ allContent = [], fallbackImg = false, ...props }) {
  const getComponentForContent = (contentItem) => {
    switch (contentItem.type) {
      case 'bio':
        return contentItem.bio !== '' ? (
          <Bio {...props} bio={contentItem.bio} />
        ) : null
      case 'polaroids':
        return <Polaroids {...props} images={contentItem.assets} />
      case 'covers':
        return <Covers {...props} images={contentItem.assets} />
      case 'campaigns':
        return (
          <Portfolio
            {...props}
            images={contentItem.assets}
            fallbackImg={false}
            customBook={true}
          />
        )
      case 'video':
      case 'videos': // Added 'videos' to handle this case
        return <Videos {...props} videos={contentItem.assets} />
      case 'books':
        if (contentItem.slug === 'video' || contentItem.slug === 'videos') {
          return <Videos {...props} videos={contentItem.assets} />
        } else {
          return <Portfolio {...props} images={contentItem.assets} />
        }
      case 'portfolio':
        return (
          <Portfolio
            {...props}
            images={contentItem.assets}
            fallbackImg={fallbackImg}
          />
        )
      case 'runways':
        return <Portfolio {...props} images={contentItem.assets} />
      default:
        // Fallback for any content type with assets
        if (contentItem?.assets?.length > 1) {
          return <Portfolio {...props} images={contentItem.assets} />
        }
        return null
    }
  }

  return (
    <div className={s.container}>
      {allContent.map((contentItem) => {
        const component = getComponentForContent(contentItem)
        if (!component) {
          return null
        }
        return (
          <CollapsibleContent
            key={contentItem.scrollSpyId}
            id={contentItem.scrollSpyId}
            name={contentItem.typeName}
          >
            {component}
          </CollapsibleContent>
        )
      })}
    </div>
  )
}

ModelContent.propTypes = {
  allContent: PropTypes.array,
  fallbackImg: PropTypes.bool,
}

export default ModelContent
